/* eslint-disable simple-import-sort/imports */
import Container from 'components/Container';
import React, { useEffect, useRef } from 'react';

import { dataLogoCarousel } from './data-LogoCarousel';
import {
  CarouselContainer,
  CarouselTrack,
  GradientLeft,
  GradientRight,
  LogoImage,
  LogoLink,
  LogoSlide,
  SectionLogoCarousel,
} from './styles.js';

const LogoCarouselSection = () => {
  const trackRef = useRef(null);
  const animationFrameRef = useRef(null);
  const positionRef = useRef(0);
  const isPausedRef = useRef(false);
  const speed = 1;

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const getTrackWidth = () => {
      if (!track) return 0;
      return track.scrollWidth / 2;
    };

    const animate = () => {
      if (!track || isPausedRef.current) {
        animationFrameRef.current = requestAnimationFrame(animate);
        return;
      }

      positionRef.current -= speed;
      const trackWidth = getTrackWidth();

      if (trackWidth > 0 && Math.abs(positionRef.current) >= trackWidth) {
        positionRef.current += trackWidth;
      }

      track.style.transform = `translateX(${positionRef.current}px)`;

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animationFrameRef.current = requestAnimationFrame(animate);

    const handleResize = () => {
      if (track) {
        const trackWidth = getTrackWidth();
        if (trackWidth > 0) {
          const currentPosition = Math.abs(positionRef.current);
          if (currentPosition >= trackWidth) {
            positionRef.current = -(currentPosition % trackWidth);
          }
        }
      }
    };

    let resizeTimeout;
    const debouncedResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    };

    window.addEventListener('resize', debouncedResize);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      window.removeEventListener('resize', debouncedResize);
      clearTimeout(resizeTimeout);
    };
  }, []);

  const handleMouseEnter = () => {
    isPausedRef.current = true;
  };

  const handleMouseLeave = () => {
    isPausedRef.current = false;
  };

  const duplicatedLogos = [
    ...dataLogoCarousel.logos,
    ...dataLogoCarousel.logos,
  ];

  return (
    <SectionLogoCarousel>
      <Container>
        <CarouselContainer
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <GradientLeft />
          <CarouselTrack ref={trackRef} $spaceBetween={20}>
            {duplicatedLogos.map((logo, idx) => (
              <LogoSlide key={`logo-${idx}`}>
                {logo.href ? (
                  <LogoLink
                    href={logo.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LogoImage src={logo.src} alt={logo.alt} />
                  </LogoLink>
                ) : (
                  <LogoImage src={logo.src} alt={logo.alt} />
                )}
              </LogoSlide>
            ))}
          </CarouselTrack>
          <GradientRight />
        </CarouselContainer>
      </Container>
    </SectionLogoCarousel>
  );
};

export default LogoCarouselSection;
